
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22 12a9 9 0 01-9 9 8.892 8.892 0 01-5.16-1.63.504.504 0 01-.07-.76l.72-.73a.5.5 0 01.63-.06A6.903 6.903 0 0013 19a7 7 0 10-7-7h2.36a.488.488 0 01.36.15l.2.2a.5.5 0 010 .71L5.39 16.6a.51.51 0 01-.71 0l-3.53-3.54a.5.5 0 010-.71l.2-.2a.488.488 0 01.36-.15H4a9 9 0 0118 0zm-8.62-5h-.76a.5.5 0 00-.5.5v4.66a.529.529 0 00.15.35l3.29 3.29a.5.5 0 00.71 0l.53-.53a.5.5 0 000-.71l-2.92-2.92V7.5a.504.504 0 00-.146-.354A.504.504 0 0013.38 7z"}})])
          )
        }
      }
    